/**
 * @file useProductNoteLinks.ts
 * @description Ссылки из панелей элементов данных товара (phase19.16 Р2а;
 * uiux-design-r2a §3): «Открыть товар-пример →» — карточка товара, который
 * сейчас на канве шаблона (выбранный «Товар для примера» или пример
 * сервера), и «Изменить →» — сведения о продавце в «Настройках сайта».
 * Вне конструктора (тесты, превью) ссылки товара нет.
 */

import { useContext } from "react";

import { BuilderContext } from "../../components/site-builder/builder-context";
import { useCurrentContext } from "../../auth/hooks";
import { builderLink } from "../../lib/site-builder/selection";

export interface NoteLink {
  to: string;
  label: string;
}

export function useSampleProductLink(): NoteLink | null {
  const slug = useCurrentContext()?.shop?.slug ?? "";
  const b = useContext(BuilderContext);
  const sample = b?.canvasTarget?.product ?? b?.pages.template?.sample ?? null;
  return sample && slug ? { to: `/shop/${slug}/catalog/products/${sample.productId}`, label: "Открыть товар-пример →" } : null;
}

export function useSellerSettingsLink(): NoteLink | null {
  const slug = useCurrentContext()?.shop?.slug ?? "";
  return slug ? { to: builderLink(slug, { panel: "settings", sub: "seller" }), label: "Изменить →" } : null;
}
